module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._v("这里是主页")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5285a4dd!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 27
// module chunks = 0